module.exports = __webpack_public_path__ + "static/img/40007 (1).4cb37a6.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/40000/40007 (1).webp
// module id = vNPE
// module chunks = 14